let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("4g2Xt")]).then(() => parcelRequire('e9FEZ'));